module.exports = __webpack_public_path__ + "img/eg.c39a7f7.svg";